import React, { useState, useContext, Fragment, useEffect } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Navigate } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@mui/styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  PendingActionsOutlined,
  DoDisturbOnOutlined,
  Close,
  InsertCommentOutlined,
} from "@mui/icons-material";
import clsx from "clsx";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import axios from "axios";
import {
  Card,
  CardContent,
  Box,
  Grid,
  Alert,
  TextField,
  ClickAwayListener,
  Slide,
  Snackbar,
  Typography,
  Dialog,
  DialogContent,
  DialogActions,
  FormControl,
} from "@mui/material";
import { Calendar } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { format, addDays } from "date-fns";
import { es } from "date-fns/locale";
import Moment from "moment";

import LoadClients from "components/Services/LoadClients";
import ExcelReportClientsTransactions from "views/Print/ExcelReportClientsTransactions";
import TransactionPaymentClientsAdmin from "views/Dialog/TransactionPaymentClientsAdmin";
import loaderGif from "assets/img/loading.gif";

import {
  cardBodyStyle,
  ButtonStyle0,
  blackColor,
  ButtonTableGrid1,
  ButtonExit,
} from "components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

// Crea un tema personalizado
const theme = createTheme({
  components: {
    MuiTablePagination: {
      styleOverrides: {
        displayedRows: {
          color: "black", // Cambia el color del texto a negro
        },
      },
    },
  },
});

export default function TransactionsClients(props) {
  const classes = useStyles();

  const [rows, setRows] = useState([]);
  const [rowsId, setRowsId] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [loader, setLoader] = useState(true);
  const [openPaymentClient, setOpenPaymentClient] = useState(false);
  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [returnLogin, setReturnLogin] = React.useState(false);
  const [totalPending, setTotalPending] = React.useState("0.00");
  const { urlServices, UserAuth } = useContext(UrlServicesContext);
  const [openNotification, setOpenNotification] = useState(false);

  let keyAuthorization = UserAuth.Session;

  const [showStartCalendar, setShowStartCalendar] = useState(false);
  const [showEndCalendar, setShowEndCalendar] = useState(false);
  const [dateStart, setDateStart] = useState(false);
  const [dateEnd, setDateEnd] = useState(false);
  const [alert, setAlert] = React.useState({
    openAlert: false,
    errorAlert: "error",
    mensaje: "",
  });

  const [values, setValues] = useState({
    endLink: null,
    startLink: null,
    clients: null,
    clientsData: "",
    notification: "",
    notificationOld: "",
    notidicationDateOld: "",
    errorNotification: false,
  });

  const handleChange = (prop, value) => {
    setValues((prevValues) => ({
      ...prevValues,
      [prop]: value,
      errorNotification: false,
    }));

    setAlert((prevAlert) => ({
      ...prevAlert,
      openAlert: false,
    }));
  };

  const [state] = useState({
    columns: [
      {
        headerName: "Ref.",
        field: "reference",
        width: 100,
        headerAlign: "center",
        align: "center",
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        renderCell: (params) => {
          return (
            <Alert severity="info" icon={false}>
              <b style={{ fontSize: 10 }}>{params.value} </b>
            </Alert>
          );
        },
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "Cliente",
        field: "client",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          return (
            <span style={{ fontSize: 12 }}>
              {params.row.client.companyName}{" "}
            </span>
          );
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        flex: 1,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      /* {
        headerName: "SubTotal",
        field: "subTotal",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          return <b style={{ fontSize: 12 }}>{`$${params.row.subTotal}`}</b>;
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        width: 90,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "Iva %",
        field: "iva",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          return <b style={{ fontSize: 12 }}>{`$${params.row.ivaSubtotal}`}</b>;
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        width: 90,
        sortable: false,
        filtering: false,
        hideable: false,
      },*/
      {
        headerName: "Total",
        field: "total",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          return <b style={{ fontSize: 12 }}>{`$${params.row.total}`}</b>;
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        width: 90,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "Comisión Cliente",
        field: "client.percentage",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          return (
            <b
              style={{
                fontSize: 12,
                padding: 4,
              }}
            >
              {parseInt(params.row.client.percentage)}%
            </b>
          ); // Mostrar el valor con dos decimales
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        width: 140,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "Comisión total",
        field: "percentageTotal",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          return (
            <b
              style={{
                fontSize: 12,
                padding: 4,
                background: "rgb(237, 247, 237)",
              }}
            >
              ${parseFloat(params.row.commissionPayment).toFixed(2)}
            </b>
          ); // Mostrar el valor con dos decimales
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        width: 130,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "Total a Transferir",
        field: "commissionPaymentTotal",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          return (
            <b style={{ fontSize: 12 }}>{`$${parseFloat(
              params.row.commissionPaymentTotal,
            ).toFixed(2)}`}</b>
          );
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        width: 130,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "Creación",
        field: "paymentTransactions",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          return (
            <span>
              {params.row.paymentTransactions.length > 0
                ? Moment(params.row.paymentTransactions[0].createdAt).format(
                    "DD-MM-YYYY",
                  )
                : ""}{" "}
            </span>
          );
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        width: 110,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "---",
        field: "action0",
        headerClassName: "super-app-theme--header",
        width: 100,
        headerAlign: "center",
        renderCell: (params) => {
          return (
            <Grid container>
              <Grid item xs={12} sm={12}>
                <ButtonTableGrid1
                  onClick={handleNotificationValue(params)}
                  style={{
                    margin: "5px 0",
                    fontSize: 10,
                    width: 80,
                    background: "slategrey",
                  }}
                >
                  Notificación
                </ButtonTableGrid1>
              </Grid>
            </Grid>
          );
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "---",
        field: "action",
        headerClassName: "super-app-theme--header",
        width: 100,
        headerAlign: "center",
        renderCell: (params) => {
          return (
            <Grid container>
              <Grid item xs={12} sm={12}>
                <ButtonTableGrid1
                  onClick={handlePaidValue(params)}
                  style={{ margin: "5px 0", fontSize: 10, width: 80 }}
                >
                  PAGAR
                </ButtonTableGrid1>
              </Grid>
            </Grid>
          );
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        sortable: false,
        filtering: false,
        hideable: false,
      },
    ],
  });

  const RefreshTable = (filterValues = values) => {
    axios
      .get(`${urlServices}payment-link/transactions-clients`, {
        headers: {
          Authorization: "Bearer " + keyAuthorization,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          let filteredData = response.data;

          // Aplicar filtros solo si todos los valores necesarios están presentes
          if (values.startLink && values.endLink) {
            // Formatear fechas una sola vez (fuera del filter para mejor performance)
            const fromDate = Moment(values.startLink).format("YYYY-MM-DD");
            const toDate = Moment(values.endLink).format("YYYY-MM-DD");

            // Luego filtramos sus transacciones manteniendo la estructura original
            filteredData = filteredData
              .map((client) => ({
                ...client,
                paymentTransactions:
                  client.paymentTransactions?.filter((transaction) => {
                    const transactionDate = Moment(
                      transaction.createdAt,
                    ).format("YYYY-MM-DD");
                    return (
                      transactionDate >= fromDate && transactionDate <= toDate
                    );
                  }) || [],
              }))
              .filter((client) => client.paymentTransactions.length > 0); // Opcional: eliminar clientes sin transacciones
          }

          if (values.clients) {
            filteredData = filteredData.filter(
              (client) => client.clientsId === values.clients,
            );
          }

          let totalPendingValue = 0;

          let dataFinal = filteredData.map((data) => {
            const commissionPercentage = parseFloat(
              data.client?.percentage || 0,
            );
            const payTotal = parseFloat(data.total || 0);

            // Cálculo de la comisión
            const commission = (commissionPercentage * payTotal) / 100;

            // Cálculo del total a transferir (total - comisión)
            const transferAmount = payTotal - commission;

            totalPendingValue += transferAmount;
            return {
              ...data,
              commissionPayment: commission.toFixed(2),
              commissionPaymentTotal: transferAmount.toFixed(2),
            };
          });

          setTotalPending(totalPendingValue);
          setTotalRows(filteredData.length);
          setRows(dataFinal);
          setLoader(false);
        }
      })
      .catch((e) => {
        if (e.response.status === 401) {
          setMensageSystem(
            "La sesión ha expirado, vuelva a iniciar sesión ...",
          );
          setError(true);

          setTimeout(() => {
            localStorage.clear();
            setReturnLogin(true);
          }, 4000);
        } else if (e.response.status === 500) {
          setRows([]);
          setMensageSystem("Error en la consulta con sel servidor.");
          setError(true);
        }
        setLoader(false);
      });
  };

  useEffect(() => {
    RefreshTable();
  }, [values.clients, values.startLink, values.endLink]);

  const changeClients = (data) => {
    const newValues = {
      ...values,
      clients: data !== null ? data.id : null,
      clientsData: data !== null ? data : "",
    };

    setValues(newValues);

    // Llama a RefreshTable con los nuevos valores inmediatamente
    RefreshTable(newValues);
  };

  // Manejar cambio de fecha inicial
  const handleDateStartChange = (date) => {
    setDateStart(date);
    const formattedDate = format(date, "yyyy/MM/dd");

    if (dateEnd && dateEnd <= date) {
      setDateEnd(null);
      setValues((prev) => ({ ...prev, endLink: "" }));
    }

    setValues((prev) => ({
      ...prev,
      startLink: formattedDate,
    }));
    setShowStartCalendar(false);
  };

  // Manejar cambio de fecha final
  const handleDateEndChange = (date) => {
    setDateEnd(date);
    const formattedDate = format(date, "yyyy/MM/dd");

    setValues((prev) => ({
      ...prev,
      endLink: formattedDate,
    }));
    setShowEndCalendar(false);
  };

  const changeClientsDeleteFilter = () => {
    const newValues = {
      ...values,
      clients: null,
      clientsData: "",
    };

    setValues(newValues);

    // Llama a RefreshTable con los nuevos valores inmediatamente
    RefreshTable(newValues);
  };

  const changeCalendarDeleteFilter = () => {
    const newValues = {
      ...values,
      endLink: null,
      startLink: null,
    };

    setValues(newValues);
    setDateStart(false);
    setDateEnd(false);

    // Llama a RefreshTable con los nuevos valores inmediatamente
    RefreshTable(newValues);
  };

  const handlePaidValue = (data) => () => {
    setRowsId(data.row);
    setOpenPaymentClient(true);
  };

  const handleNotificationValue = (data) => () => {
    setRowsId(data.row);

    let message = "";

    if (data.row.notification) {
      message = JSON.parse(data.row.notification);
    }

    setValues((prevValues) => ({
      ...prevValues,
      notification: "",
      notificationOld: message ? message.message : "",
      notidicationDateOld: message ? message.date : "",
    }));

    setOpenNotification(true);
  };

  const handleClosePaymentClient = () => setOpenPaymentClient(false);
  const handleCloseNotification = () => setOpenNotification(false);

  const handleSearch = () => () => {
    setAlert({ openAlert: false });

    if (!values.clients) {
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Debe seleccionar un cliente",
      });
      return;
    }

    if (!values.startLink) {
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Debe seleccionar una fecha inicial",
      });
      return;
    }

    if (!values.endLink) {
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Debe seleccionar una fecha final",
      });
      return;
    }

    RefreshTable();
  };

  const submitFormNotification = async () => {
    if (!values.notification) {
      setValues({
        ...values,
        errorNotification: true,
      });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Debe agregar un mensaje",
      });
      return;
    }

    try {
      const dataValue = {
        notification: JSON.stringify({
          date: Moment().format("DD-MM-YYYY"),
          message: values.notification,
        }),
      };

      const response = await axios.put(
        `${urlServices}payment-link/${rowsId.id}`,
        dataValue,
        {
          headers: {
            Authorization: "Bearer " + keyAuthorization,
          },
        },
      );

      if (response.status === 200) {
        setAlert({
          ...alert,
          openAlert: true,
          errorAlert: "success",
          mensaje: "Mensaje enviado al cliente",
        });
        RefreshTable();
        setOpenNotification(false);
      }
    } catch (error) {}
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ openAlert: false });
  };

  if (returnLogin) {
    return <Navigate to="/" />;
  }

  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <Card
          sx={{ margin: { xs: "60px 0", sm: "10px 0" } }}
          variant="outlined"
        >
          <CardContent sx={{ mb: 20 }}>
            {error ? <Alert severity="error">{mensageSystem}</Alert> : ""}
            {loader ? (
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <center>
                    <img
                      alt="loaderGif"
                      src={loaderGif}
                      style={{ width: 60, margin: "20% 0" }}
                    />
                  </center>
                </Grid>
              </Grid>
            ) : (
              <Fragment>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={7} sx={{ mt: 3 }}>
                    <div className={classes.cardTitleBlack}>
                      <PendingActionsOutlined className={classes.iconFilter} />{" "}
                      Transacciones pendientes por pagar
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={5}>
                    <Box
                      sx={{
                        fontSize: 26,
                        fontWeight: "bold",
                        borderRadius: 2,
                        p: 3,
                        background:
                          "linear-gradient(145deg, rgb(253, 237, 237), rgb(253, 237, 237, 0.3))",
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05)",
                        width: "100%",
                        // maxWidth: 200,
                        height: 95,
                        //margin: '0 auto',
                        // border: '1px solid',
                        // borderColor: 'divider',
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "left",
                        "&:hover": {
                          boxShadow: "0 6px 12px rgba(0, 0, 0, 0.1)",
                        },
                      }}
                    >
                      <Typography
                        sx={{
                          color: "rgb(95, 33, 32)",
                          mb: 1,
                          fontWeight: "bold",
                          fontSize: 26,
                        }}
                      >
                        Saldo{" "}
                        <span style={{ fontSize: 10, marginRight: 35 }}>
                          (Pendiente)
                        </span>{" "}
                        {parseFloat(totalPending).toFixed(2)}
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          color: "text.secondary",
                          fontSize: 12,
                          textAlign: "right",
                        }}
                      >
                        USD
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <div
                      className={classes.cardTitleBlack}
                      style={{ fontSize: 14 }}
                    >
                      Aplicar filtros:
                    </div>
                  </Grid>

                  <Grid item xs={12} md={3} sx={{ mt: 1 }}>
                    <ClickAwayListener
                      onClickAway={() => setShowStartCalendar(false)}
                    >
                      <Box sx={{ position: "relative" }}>
                        <TextField
                          fullWidth
                          label="Fecha inicial"
                          value={
                            dateStart ? format(dateStart, "dd/MM/yyyy") : ""
                          }
                          onClick={() =>
                            setShowStartCalendar(!showStartCalendar)
                          }
                          InputProps={{
                            readOnly: true,
                          }}
                          size="small"
                        />
                        {showStartCalendar && (
                          <Box
                            sx={{
                              position: "absolute",
                              zIndex: 1300,
                              mt: 1,
                              "& .rdrCalendarWrapper": {
                                borderRadius: "8px",
                                boxShadow: 3,
                                width: "100%",
                              },
                            }}
                          >
                            <Calendar
                              date={dateStart}
                              onChange={handleDateStartChange}
                              locale={es}
                              color={blackColor}
                            />
                          </Box>
                        )}
                      </Box>
                    </ClickAwayListener>
                  </Grid>

                  <Grid item xs={12} md={3} sx={{ mt: 1 }}>
                    <ClickAwayListener
                      onClickAway={() => setShowEndCalendar(false)}
                    >
                      <Box sx={{ position: "relative" }}>
                        <TextField
                          fullWidth
                          label="Fecha final"
                          value={dateEnd ? format(dateEnd, "dd/MM/yyyy") : ""}
                          onClick={() => setShowEndCalendar(!showEndCalendar)}
                          InputProps={{
                            readOnly: true,
                          }}
                          disabled={!dateStart}
                          size="small"
                        />
                        {showEndCalendar && (
                          <Box
                            sx={{
                              position: "absolute",
                              zIndex: 1300,
                              mt: 1,
                              "& .rdrCalendarWrapper": {
                                borderRadius: "8px",
                                boxShadow: 3,
                                width: "100%",
                              },
                            }}
                          >
                            <Calendar
                              date={dateEnd}
                              onChange={handleDateEndChange}
                              locale={es}
                              color={blackColor}
                              minDate={
                                dateStart ? addDays(dateStart, 1) : undefined
                              }
                            />
                          </Box>
                        )}
                      </Box>
                    </ClickAwayListener>
                    <b
                      style={{
                        fontSize: 10,
                        color: "red",
                        cursor: "pointer",
                        display: dateEnd ? "block" : "none",
                        marginTop: 5,
                      }}
                      onClick={changeCalendarDeleteFilter}
                    >
                      <Close sx={{ fontSize: 18 }} /> ELIMINAR FILTRO
                    </b>
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    {/* Campo de filtro clients */}
                    <LoadClients
                      value={values.clientsData}
                      refresh={changeClients}
                    />
                    <b
                      style={{
                        fontSize: 10,
                        color: "red",
                        cursor: "pointer",
                        display: values.clients ? "block" : "none",
                        marginTop: 2,
                      }}
                      onClick={changeClientsDeleteFilter}
                    >
                      <Close sx={{ fontSize: 18 }} /> ELIMINAR FILTRO
                    </b>
                  </Grid>
                  {/*<Grid item xs={12} sm={3} sx={{ mt: 1 }}>
                    <ButtonStyle0
                      style={{ fontSize: 12, width: 130, marginTop: 3 }}
                      onClick={handleSearch()}
                    >
                      Aplicar filtro
                    </ButtonStyle0>
                  </Grid>*/}
                  <Grid item xs={12} sm={12}>
                    <Box style={{ float: "right" }}>
                      <span
                        className={classes.cardTitleBlack}
                        style={{ fontSize: 14, marginRight: 20 }}
                      >
                        Total registro{totalRows > 1 ? "s" : ""}:
                        {" " + totalRows}
                      </span>
                      <ExcelReportClientsTransactions
                        excelData={rows}
                        fileName={`Exportar_excel_clientes_transaccion`}
                        disabled={rows.length > 0 ? false : true}
                      />
                    </Box>
                  </Grid>
                </Grid>
                <Grid container>
                  {rows.length > 0 ? (
                    <Grid item xs={12} sm={12}>
                      <Box
                        sx={{
                          "& .super-app.celAll": {
                            fontSize: 12,
                            //backgroundColor: 'rgba(255, 7, 0, 0.55)',
                          },
                          "& .super-app.celActions": {
                            backgroundColor: "rgb(242, 242, 242)",
                          },
                          "& .super-app-theme--header": {
                            backgroundColor: "rgb(242, 242, 242)",
                          },
                          marginTop: 2,
                        }}
                      >
                        <ThemeProvider theme={theme}>
                          <DataGrid
                            rows={rows}
                            columns={state.columns}
                            loading={loader}
                            initialState={{
                              pagination: {
                                paginationModel: { page: 0, pageSize: 100 },
                              },
                            }}
                            pageSizeOptions={[5, 10, 20, 100]}
                            disableRowSelectionOnClick={true}
                            checkboxSelection={false}
                            sx={{
                              [`& .${gridClasses.cell}`]: {
                                display: "flex",
                                alignItems: "center", // Alineación vertical
                                // justifyContent: 'center', // Alineación horizontal
                                wordWrap: "break-word !important",
                                whiteSpace: "normal !important",
                              },
                              /* [`& .${gridClasses.columnHeaderTitle}`]: {
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                },*/
                            }}
                            getRowHeight={() => "auto"}
                            // autoHeights
                            autoWidth
                          />
                        </ThemeProvider>
                      </Box>
                    </Grid>
                  ) : (
                    <Grid item xs={12} sm={12} sx={{ py: 5 }}>
                      <center>
                        <DoDisturbOnOutlined
                          sx={{ fontSize: 46, color: "#ccc" }}
                        />
                        <br></br>
                        <b
                          style={{
                            fontSize: 18,
                            margin: "5px 0 70px 0",
                            color: "#ccc",
                          }}
                        >
                          No hay registros para mostrar
                        </b>
                      </center>
                    </Grid>
                  )}
                </Grid>
              </Fragment>
            )}
          </CardContent>
        </Card>
      </Grid>
      {alert.openAlert && (
        <Snackbar
          open={true}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={handleCloseAlert}
        >
          <Slide direction="up" in={true} mountOnEnter unmountOnExit>
            <Alert
              onClose={handleCloseAlert}
              severity={alert.errorAlert === "error" ? "error" : "success"}
              elevation={6}
              variant="filled"
            >
              {alert.mensaje}
            </Alert>
          </Slide>
        </Snackbar>
      )}
      {openPaymentClient && (
        <TransactionPaymentClientsAdmin
          open={openPaymentClient}
          exit={handleClosePaymentClient}
          callBackRefresh={RefreshTable}
          id={rowsId}
        />
      )}
      <Dialog
        fullWidth
        maxWidth="sm"
        onClose={handleCloseNotification}
        aria-labelledby="customized-dialog-title"
        open={openNotification}
        keepMounted
        scroll="body"
        PaperProps={{
          sx: {
            borderRadius: 6,
          },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <Grid container className={classes.containerProfile}>
            <Grid item xs={12} sm={12}>
              <div className={classes.titleCardFilter}>
                Notificación al cliente de este pago
              </div>
              <div className={classes.lineBottom}></div>
              <br></br>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              sx={{
                marginTop: 1,
                fontSize: 14,
                fontWeight: "550",
                color: "green",
              }}
            >
              Retiro solicitado: ${parseFloat(rowsId.commissionPaymentTotal)}
            </Grid>
            {values.notificationOld && (
              <Grid item xs={12} sm={12} sx={{ my: 3 }}>
                <Box sx={{ p: 2, border: "1px solid #F1F1F1" }}>
                  <b
                    className={classes.cardTitleBlack}
                    style={{ fontSize: 14, fontWeight: 500, marginBottom: 2 }}
                  >
                    Mensaje anterior enviado:{" "}
                    <span style={{ float: "right" }}>
                      {values.notidicationDateOld}
                    </span>
                  </b>

                  <Alert severity="info" icon={<InsertCommentOutlined />}>
                    {values.notificationOld}
                  </Alert>
                </Box>
              </Grid>
            )}
            <Grid item xs={12} sm={12} sx={{ marginTop: 1 }}>
              <b
                className={classes.cardTitleBlack}
                style={{ fontSize: 14, fontWeight: 500 }}
              >
                Nuevo mensaje
              </b>
            </Grid>
            <Grid item xs={12} sm={12}>
              <FormControl style={{ width: "100%" }}>
                <TextField
                  name="notification"
                  value={values.notification}
                  error={values.errorNotification}
                  onChange={(event) => {
                    // Limitar el valor a 255 caracteres
                    const newValue = event.target.value.slice(0, 255);
                    handleChange("notification", newValue);
                  }}
                  inputProps={{
                    maxLength: 255, // Esto evita que se escriban más de 255 caracteres
                  }}
                  FormHelperTextProps={{
                    style: {
                      marginLeft: 0, // Estilo opcional para el helper text
                    },
                  }}
                  helperText={
                    <span
                      style={{
                        textAlign: "right",
                        display: "block",
                        width: "100%",
                      }}
                    >
                      {values.notification?.length || 0}/255
                    </span>
                  }
                  fullWidth
                  required
                  margin="dense"
                  autoComplete="off"
                  variant="outlined"
                  size="small"
                  multiline
                  rows={5}
                  placeholder="Ingresar..."
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12}>
              <br></br>
              <center>
                <ButtonStyle0 type="submit" onClick={submitFormNotification}>
                  Enviar
                </ButtonStyle0>
              </center>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <ButtonExit onClick={handleCloseNotification}>Cerrar</ButtonExit>
        </DialogActions>
      </Dialog>
    </Grid>
  );
}
